import {styled} from '@mui/material';

const RadioContainer = styled('div')<{
	$isError: boolean;
}>`
	padding: 16px 8px;
	border: 1px solid
		${({theme, $isError}) =>
			$isError ? theme.palette.text.error : theme.colors.gray['30Percent']};
	border-radius: 8px;
	gap: 12px;
	display: flex;
`;

export {RadioContainer};
